import { render, staticRenderFns } from "./SearchForm.component.vue?vue&type=template&id=689ab6aa&"
import script from "./SearchForm.component.vue?vue&type=script&lang=ts&"
export * from "./SearchForm.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports